import { createFileRoute } from '@tanstack/react-router';
import Settings from '@src/pages/Settings';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/settings')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('settings.page_title', 'Settings') }],
  }),
  component: Settings,
});
